// extracted by mini-css-extract-plugin
module.exports = {"goBack":"blog-module--goBack--1RWFk"};